import {useQueryClient} from "@tanstack/react-query";
import {useNavigate, useSearchParams} from 'react-router';
import api from '../../utils/api';
import {useEffect} from 'react';
import LoaderIndicator from "../../components/Loader/LoaderIndicator";


const AuthorizePage = () => {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const [urlSearchParams] = useSearchParams();
    const code = urlSearchParams.get('code')
    let [state, remember, forward] = urlSearchParams.get('state').split('|');

    useEffect(() => {
        if(forward === '/login' || !forward) {
            forward = '/';
        }
        if (code !== '') {
            //console.log('logging into backend', code, state);
            if(state==='login') {
                api.post('/login', {code, remember})
                             .then((res) => {
                                 console.log(res);
                                 queryClient.invalidateQueries(['user']);
                                 navigate(forward);
                             })
                             .catch(error => {
                                 console.error(error); //todo proper error handling
                                 navigate('/login');
                             }, []);
            } else if(state==='grant') {
                api.post('/swc/permissions', {code})
                             .then(() => {
                                 navigate('/user/api-permissions');
                             })
                             .catch(error => {
                                 console.error(error); //todo proper error handling
                                 navigate('/user/api-permissions');
                             }, []);
            } else {
                console.error('Invalid return state');
            }

        }
    }, []);

    return <div style={{marginTop: 18}}><LoaderIndicator id="authorize" message="Processing OAuth..." strokeWidth={3}/></div>;
}

export default AuthorizePage;
